<template>
<div>
    <!-- 图片区 列表页 from个人用户-->
    <div v-if="data.dataSource === PUBLISHSOURCE.PERSON || data.dataSource === 3">
        <div v-if="inDetailPage">
            <cmui-slider class="discoverSlider" :items="data.imageUrls" :theme="8">
                <cmui-slider-item v-for="item in data.imageUrls" >
                    <!-- 判断是否有视频 -->
                    <img :src="item.imageUrl" alt="" v-if="!item.videoUrl">
                    <div class="pos-r text-center" style="width:100%;background:rgba(0,0,0,.4)" v-if="item.videoUrl">
                        <img :src="item.imageUrl" onerror="this.src='//img1.tg-img.com/tgou2/img2/bg-load.png'" :width="item.width < item.height ? '60%' : '100%'">
                        <video v-show="videoPlaying==$index" width="100%" class="pos-a top0 bottom0 left0 right0" height="100%" class="bg-black" :poster="item.imageUrl">
                            <source :src="item.videoUrl||data.videoUrl" type="video/mp4" />
                        </video>
                        <div v-show="videoPlaying!=$index" class="pos-a top0 bottom0 left0 right0" :style="'background: url('+item.imageUrl+') center no-repeat;background-size: contain;'" @click="playVideo($index,item)">
                            <div class="discoverPlay2 border-round flex-container center pos-a">
                                <i class="icon-discover_play text-white" style="font-size:24px;margin-left: 3px;"></i>
                            </div>
                        </div>
                    </div>
                </cmui-slider-item>
            </cmui-slider>
        </div>
    </div>
    <div class="paddingh30 bg-white" :class="show == 'my' ? 'paddingt20' : 'paddingt40'">
        <!-- 头像区 -->
        <div class="flex-container paddingb20">
            <div class="flex-container left flex1">
                <div class="pos-r">
                    <div>
                        <div v-if="data.dataSource!==3" style="width:35px;height:35px;overflow: hidden;" class="border-round"
                             @click="notice">
                            <img alt="" width="100%" :src="data.headImageUrl">
                        </div>
                        <a v-else :href="show=='my'?data.headerClickUrl.replace('hisDiscover', 'myDiscover').replace('id=', 'from=detail&id='):data.headerClickUrl" v-if="!inMyPage" :data-scp="$options.name+'.00'">
                            <div style="width:35px;height:35px;overflow: hidden;" class="border-round"><img alt="" width="100%" :src="data.headImageUrl"></div>
                        </a>
                    </div>
                    <div v-show="data.roleType == 4" class="member pos-a border-round text-center right0 bottom0 flex-container center">
                        <!-- <i class="icon-pd_crown text-white text-white" style="font-size: 9px;"></i> -->
                        <!-- <img src="//image1.51tiangou.com/tgou2/img2/discover/icon-daren.png" width="15" alt=""> -->
                    </div>
                </div>
                <div class="paddingl20">
                    <div class="text-limit1">
                        <span class="text-darker fs-14" v-text="data.nickName"></span><span class="fs-10 paddingl10 text-red" v-show="data.roleType == 4 ">
                    <i class="icon-discover_daren" style="font-size: 9px;"></i><span>官方</span></span>
                    </div>
                    <div class="text-light fs-10 text-limit1">
                        <span>{{data.timeStr}}</span>
                        <!-- <span class="paddingl20">{{data.storeName}}</span> -->
                    </div>
                </div>
            </div>
            <div class="flex-container left" v-show="data.dataSource===3">
                <div style="padding:5px 10px 5px 8px;min-width: 60px;" class="badge badge-big badge-pill badge-red"
                     :data-scp="$options.name+'.follow'"
                     v-show="show!='my'&&!data.hasConcerned && data.dataSource === 3"
                     ><!-- 关注之后就不显示关注按钮 -->
                    <div class="flex-container" @click="concern(data.memberId, data.hasConcerned, data)">
                        <i class="icon-add fs-14"></i>
                        <span class="dis-i paddingl10 fs-12" v-text="'关注'"></span>
                    </div>
                </div>
                <div style="padding:5px 10px;min-width: 60px;"
                     :data-scp="$options.name+'.chat'"
                     v-if="isWeixin"
                     class="badge badge-orange badge-big badge-pill marginl30">
                    <div class="flex-container">
                        <span class="icon-chat fs-10" style="font-weight: bolder"></span>
                        <span class="paddingl10 fs-12" v-on:click="chat(data.memberId)" style="line-height: 14px;">聊聊</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 标签区 -->
        <div class="overflow-h margint20" style="height:22px;" v-if="data.labels">
            <div class="badge badge-pill badge-big badge-reverse badge-red marginr30" style="font-size:12px;padding: 3px 9px;" v-for="item in data.labels"><a :href="item.clickUrl"><span class="dis-i fs-11 text-red">{{item.labelName}}</span></a></div>
        </div>
        <!-- 内容区 -->
        <a :href="'javascript:void(0)'" :data-scp="$options.name+'.01'" v-if="data.content||(!data.content && !inDetailPage)">
            <pre class="text-darker paddingt20"
                 :class="inDetailPage?'':'text-limit3'"
                 style="word-wrap:break-word;white-space: pre-wrap;font-family:microsoft yahei;overflow: hidden;"
                 :style="{'max-height':inDetailPage?'auto':'65px'}"
                 v-text="data.content||data.imageUrls[0].content"></pre>
        </a>
        <div>
            <div class="marginr20 text-light dis-i fs-12" v-if="data.attentions" v-for="item in data.attentions" v-text="'@'+ item.nickName"></div>
        </div>
        <!-- 图片区 列表页 from卖家用户-->
        <div v-if="data.dataSource === PUBLISHSOURCE.SELLER">
            <div v-if="inDetailPage">
                <div v-for="item in data.imageUrls">
                    <pre v-if="item.content" class="text-darker fs-15 paddingv20 lh-16" style="word-wrap:break-word;white-space: pre-wrap;font-family:'microsoft yahei';" v-text="item.content"></pre>
                    <div class="pos-r border-radius text-center margint10" style="width:100%;background:rgba(0,0,0,.4)" v-if="item.videoUrl">
                        <img :src="item.imageUrl" onerror="this.src='//img1.tg-img.com/tgou2/img2/bg-load.png'" :width="item.width < item.height ? '60%' : '100%'">
                        <video v-show="videoPlaying==$index" width="100%" class="pos-a top0 bottom0 left0 right0" height="100%" class="bg-black border-radius" :poster="item.imageUrl">
                            <source :src="item.videoUrl||data.videoUrl" type="video/mp4" />
                        </video>
                        <div v-show="videoPlaying!=$index" class="pos-a top0 bottom0 left0 right0" :style="'background: url('+item.imageUrl+') center no-repeat;background-size: contain;'" @click="playVideo($index,item)">
                            <div class="discoverPlay2 border-round flex-container center pos-a">
                                <i class="icon-discover_play text-white" style="font-size:24px;margin-left: 3px;"></i>
                            </div>
                        </div>
                    </div>
                    <div class="margint20 marginb20 pos-r text-center" v-else>
                        <img :src="item.imageUrl"  alt="" class="border-radius">
                        <div class="discover_tag pos-a top0 left0" v-text="data.labels.labelName" :class="'label_'+ (data.labels.tagBg||'1')" v-if="data.labels.labelName && $index===0 && !item.videoUrl"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 评论区 -->
        <div class="box-row text-dark paddingb20 margint30 flex-container">
            <div class="flex1">
                <div class="flex-container left box-span3" v-if="inDetailPage">
                <i class="icon-discover_liuyan fs-15"></i><span class="marginl10 flex1 fs-14">{{data.commentSum}}</span>
                </div>
                <a :href="data.clickUrl" v-if="!inDetailPage" class="text-dark" :data-scp="$options.name+'.04'">
                    <div class="flex-container left box-span3">
                        <i class="icon-discover_liuyan fs-15"></i><span class="marginl10 flex1 fs-14">{{data.commentSum}}</span>
                    </div>
                </a>

                <div class="flex-container left box-span3" v-if="inDetailPage">
                    <i class="icon-discover_eye fs-19"></i><span class="marginl10 flex1 fs-14">{{data.browseNum}}</span>
                </div>
                <a :href="data.clickUrl" v-if="!inDetailPage" class="text-dark" :data-scp="$options.name+'.05'">
                    <div class="flex-container left box-span3">
                        <i class="icon-discover_eye fs-19"></i><span class="marginl10 flex1 fs-14">{{data.browseNum}}</span>
                    </div>
                </a>
            </div>
            <div>
                <div class="flex-container left text-blue" v-if="show == 'detail'"><i class="icon-store_position fs-11" style="width: 10px;"></i><div class="flex1 fs-11 marginl10" style="color:#25aaff"><a :href="data.storeUrl" style="color:#25aaff" :data-scp="$options.name+'.07'">{{data.storeName}}</a></div></div>
                <div v-if="!inDetailPage" @click="likeThis(data.id, data)" class="badge badge-reverse badge-big badge-pill" :data-scp="$options.name+'.06'">
                    <div class="clearfix">
                        <span class="fs-14 dis-i float-left" :style="!data.hasLiked ? 'color:#666' : 'color:#ff9faf'" :class="!data.hasLiked ? 'icon-counter_like' : 'icon-discover_like animated bounceIn'"></span>
                        <span class="dis-i float-left paddingl10 paddingr10 text-dark fs-14">{{data.likedSum}}</span>
                    </div>
                </div>
            </div>

            <!--<div v-if="inDetailPage" :class="show == 'my' ? 'box-span2 fs-11' : 'box-span3'">-->
                <!--<i class="icon-counter_love"></i><span class="marginl10">{{data.likedSum}}</span>-->
            <!--</div>--> 


            <!-- <div class="float-right fs-14 flex-container left text-dark" v-if="show == 'my' && inMyPage" @click="delDiscover(data.id)">
                <i class="icon-mine-idDel"></i><span class="marginl10 flex1">删除</span>
            </div> -->
        </div>
    </div>
</div>
</template>

<script>
import $ from 'jquery';
import maple from 'maple';
export default {
    props:{
        like:{//显示喜欢
            type:Boolean,
            default:true
        },
        show:{//my:我的发现
            type:String,
            default:''
        },
        data:{
            type: Object,
            default: null
        },
        inDetailPage:{
            type:Boolean,
            default:false
        }
        , inMyPage: {
            type: Boolean
            , default: false
        }
        , isHybrid: {
            type: Boolean
            , default: true
        }
        , isWeixin: {
            type: Boolean
            , default: true
        }
        , inHisPage: {
            type: Boolean
            , default: false
        }
    }
    , data(){
        return {
            PUBLISHSOURCE : {PERSON:1, SELLER:2}
        }
    }
    , methods: {
        delDiscover(discoverId){
            this.$dispatch('delDiscover', discoverId);
        }
        , chat(memberId){
            this.$dispatch('chat', memberId);
        }
        , playVideo(index=0,item){
            let videoIndex=index;
            if( maple.cookie('hybrid') === 'true' ){
                var imgUrl=location.protocol + item.imageUrl;
                var videoUrl=location.protocol + item.videoUrl;
                this.$dispatch('playVideo', {imgUrl,videoUrl});
            }
            else{
                if( !this.videoDOMs ){
                    this.$set('videoDOMs', []);
                    let $videos=$(this.$el).find('video');
                    $videos.each((index,el)=>{
                        this.$set('videoDOMs['+index+']', $(el)[0]);
                        $(el)[0].addEventListener('click', ()=>{
                            $(el)[0].pause();
                            this.$set('videoPlaying', -1);
                        });
                        $(el)[0].addEventListener('ended', ()=>{
                            this.$set('videoPlaying', -1);
                        });
                    })
                }
                this.$set('videoPlaying', index);
                //注意这里的逻辑，之前只支持图片或者视频中的一种，因此使用了同一个index，新需求同时支持两种，所以使用videoUrl判断是否是视频
                //这里设置了一个新的变量videoIndex来表示视频的索引
                while(index--){
                    if(!this.data.imageUrls[index].videoUrl){
                        videoIndex--
                    }
                }
                this.videoDOMs.length && this.videoDOMs[videoIndex].play();
            }
        }
        , likeThis: function(discoverId, index){   // 向上抛出事件，点击喜欢按钮
            this.$dispatch('likeThis', discoverId, index);
        }
        , concern: function(memberId, hasConcerned, data){
        	if( hasConcerned ){
        		this.$dispatch('notConcernEvent', memberId, data);
            }
            else{
		        this.$dispatch('concernEvent', memberId, data);
	        }
        }
        , notice(){
            maple.alert({
                content: '<div class="text-center">暂时无法关注该用户</div>'
            });
        }
    }
}
</script>

<style lang="scss">
    .member{
        width:15px;
        height:15px;
        background: url('//image1.51tiangou.com/tgou2/img2/discover/icon-daren.png') no-repeat;
        background-size: 100% auto;
        line-height: 15px;
    }
    .ratio-container-7x5,.ratio-container-17x20 {
        position: relative;
        font: 0/0 a;
        color: transparent;
        text-shadow: none;
        background-color: transparent;
        border: 0;
    }
    .ratio-container-7x5:before,.ratio-container-17x20:before {
        content: "";
        display: block;
        height: 0;
        font-size: 0;
    }
    .ratio-container-7x5:before {
        padding-top: 69%;
    }
    .ratio-container-17x20:before {
        padding-top: 118%;
    }
    .ratio-container-7x5 > *,.ratio-container-17x20 > *{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        font: initial;
        color: initial;
        overflow: hidden;
    }
    .ratio-container-7x5 > img,.ratio-container-17x20 > img {
        width: 100%;
        height: 100%;
    }
    .discoverPlay{
        width:55px;
        height:55px;
        background: rgba(0,0,0,.4);
        left:50%;
        top:50%;
        margin-left:-28px;
        margin-top:-28px;
    }
    .discoverPlay2 {
        width: 55px;
        height: 55px;
        background: rgba(0,0,0,.4);
        left: 50%;
        top: 50%;
        margin-left: -22.5px;
        margin-top: -22.5px;
    }
    .bottomHold .borderb {
        border-bottom: 1px solid #f3f3f3;
    }
    .tg-tabbar.theme_5 .tg-tabbar-warp {
        border-bottom: 1px solid #f3f3f3;
    }
    .animated {
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both
    }
    @-webkit-keyframes bounceIn {
        0%,100%,20%,40%,60%,80% {
            -webkit-transition-timing-function: cubic-bezier(0.215,.61,.355,1);
            transition-timing-function: cubic-bezier(0.215,.61,.355,1)
        }

        0% {
            opacity: 0;
            -webkit-transform: scale3d(.1,.1,.1);
            transform: scale3d(.1,.1,.1)
        }

        20% {
            -webkit-transform: scale3d(1.3,1.3,1.3);
            transform: scale3d(1.3,1.3,1.3)
        }

        40% {
            -webkit-transform: scale3d(.9,.9,.9);
            transform: scale3d(.9,.9,.9)
        }

        60% {
            opacity: 1;
            -webkit-transform: scale3d(1.03,1.03,1.03);
            transform: scale3d(1.03,1.03,1.03)
        }

        80% {
            -webkit-transform: scale3d(.97,.97,.97);
            transform: scale3d(.97,.97,.97)
        }

        100% {
            opacity: 1;
            -webkit-transform: scale3d(1,1,1);
            transform: scale3d(1,1,1)
        }
    }

    @keyframes bounceIn {
        0%,100%,20%,40%,60%,80% {
            -webkit-transition-timing-function: cubic-bezier(0.215,.61,.355,1);
            transition-timing-function: cubic-bezier(0.215,.61,.355,1)
        }

        0% {
            opacity: 0;
            -webkit-transform: scale3d(.1,.1,.1);
            -ms-transform: scale3d(.1,.1,.1);
            transform: scale3d(.1,.1,.1)
        }

        20% {
            -webkit-transform: scale3d(1.3,1.3,1.3);
            -ms-transform: scale3d(1.3,1.3,1.3);
            transform: scale3d(1.3,1.3,1.3)
        }

        40% {
            -webkit-transform: scale3d(.9,.9,.9);
            -ms-transform: scale3d(.9,.9,.9);
            transform: scale3d(.9,.9,.9)
        }

        60% {
            opacity: 1;
            -webkit-transform: scale3d(1.03,1.03,1.03);
            -ms-transform: scale3d(1.03,1.03,1.03);
            transform: scale3d(1.03,1.03,1.03)
        }

        80% {
            -webkit-transform: scale3d(.97,.97,.97);
            -ms-transform: scale3d(.97,.97,.97);
            transform: scale3d(.97,.97,.97)
        }

        100% {
            opacity: 1;
            -webkit-transform: scale3d(1,1,1);
            -ms-transform: scale3d(1,1,1);
            transform: scale3d(1,1,1)
        }
    }

    .bounceIn {
        -webkit-animation-name: bounceIn;
        animation-name: bounceIn;
        -webkit-animation-duration: .75s;
        animation-duration: .75s;
    }
    .discoverSlider .swiper-slide{
        height:0;
    }
    .discoverSlider .swiper-slide.swiper-slide-active{
        height:auto;
    }
    .discoverSlider .swiper-pagination-bullet{
        background: #c1c1c1;
        border: 1px solid #ebebeb;
    }
    .discoverSlider .swiper-pagination-bullet-active{
        background: #222;
    }
    .discoverSlider .swiper-slide:only-child{
        height:auto !important;
    }
</style>